import { Button, Spacer, Stack, Text, VStack } from '@chakra-ui/react';
import { Controller } from 'react-hook-form';

import {
  AlarmClockCheckIcon,
  CheckFatFilledIcon,
  CheckFatOutlineIcon,
  MousePointerClickIcon
} from '@assets/icons';

const ToggleAutoScheduleStep = ({ form }) => {
  return (
    <VStack
      h='full'
      w='full'
      justify='center'
      gap={8}
    >
      <Spacer />
      <Controller
        name='auto_schedule'
        control={form.control}
        render={({ field }) => {
          return (
            <>
              <Button
                variant='onboarding'
                borderColor={field.value ? 'brandPrimary.primary' : 'surface.outlineVariant'}
                rightIcon={field.value ? <CheckFatFilledIcon /> : <CheckFatOutlineIcon />}
                onClick={() => field.onChange(true)}
                maxH='unset'
                h='min-content'
              >
                <AlarmClockCheckIcon />
                <Stack
                  textAlign='start'
                  gap={1}
                >
                  <Text
                    variant='label-caps-600-sm'
                    fontSize='16px'
                    fontWeight={600}
                  >
                    Auto-Scheduling
                  </Text>
                  <Text
                    color='surface.onSurfaceVariant'
                    variant={{ base: 'body-reg-sm', md: 'body-reg-md' }}
                  >
                    <Text
                      as='span'
                      fontWeight={600}
                    >
                      Recommended:
                    </Text>{' '}
                    By checking this box, you’re agreeing to have FORA automatically attend your
                    meetings.
                  </Text>
                </Stack>
              </Button>
              <Button
                variant='onboarding'
                borderColor={field.value ? 'surface.outlineVariant' : 'brandPrimary.primary'}
                rightIcon={field.value ? <CheckFatOutlineIcon /> : <CheckFatFilledIcon />}
                onClick={() => field.onChange(false)}
                maxH='unset'
                h='min-content'
              >
                <MousePointerClickIcon />
                <Stack
                  textAlign='start'
                  gap={1}
                >
                  <Text
                    variant='label-caps-600-sm'
                    fontSize='16px'
                    fontWeight={600}
                  >
                    Manual Scheduling
                  </Text>
                  <Text
                    color='surface.onSurfaceVariant'
                    variant={{ base: 'body-reg-sm', md: 'body-reg-md' }}
                  >
                    By checking this box, you’re agreeing to have FORA automatically attend your
                    meetings.
                  </Text>
                </Stack>
              </Button>
            </>
          );
        }}
      />
      <Spacer />
      <Text color='surface.onSurfaceVariant'>You can change this later in Settings.</Text>
    </VStack>
  );
};

export default ToggleAutoScheduleStep;
